import { contactEntry } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">{contactEntry.title}</h2>
        <p className="text-sm text-foreground-600 text-center max-w-2xl mx-auto mb-10">{contactEntry.description}</p>

        <div className="flex flex-col md:flex-row gap-6 items-stretch">
          <div className="flex-1 bg-background-100 rounded-lg border border-background-200/60 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-800">联系邮箱</div>
                <div className="text-xs text-foreground-500">{contactEntry.email}</div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {contactEntry.features.map((feat) => (
                <span key={feat} className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                  {feat}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 bg-background-100 rounded-lg border border-background-200/60 p-6 flex flex-col justify-center items-center text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
              <i className="ri-chat-smile-2-line text-xl"></i>
            </div>
            <p className="text-sm text-foreground-600 mb-4">工作日 24 小时内回复，期待您的来信</p>
            <a
              href={`mailto:${contactEntry.email}`}
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              发送邮件
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}